import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("authPOSUser");
    localStorage.removeItem("token");

    navigate(process.env.PUBLIC_URL + "/login");
  }, [navigate]);

  return null;
};

export default Logout;
